import { useEffect, useState } from 'react'
import CarouselImageView from './CarouselImageView'
import CarouselPreview from './CarouselPreview'
import CarouselNavigators from './CarouselNavigators'

const randomId = Math.floor(Math.random() * 100)
const formatImageList = (images) =>
  images.map((img, index) => ({
    image: img.image,
    id: img.slug || `${index}-${randomId}}`,
    ...img,
  }))

const ImageCarousel = ({ images = [] }) => {
  const [imageList, setImages] = useState(formatImageList(images))
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    setImages(formatImageList(images))
    setCurrentImageIndex(0)
  }, [images])

  const setCurrentImage = (selectedImgIndex) => {
    const selectedImg = imageList[selectedImgIndex]
    const selectedElement = document.getElementById(selectedImg.id)
    selectedElement &&
      selectedElement.scrollIntoView({ block: 'nearest', inline: 'nearest' })
    setCurrentImageIndex(selectedImgIndex)
  }
  const nextImage = () => {
    if (images.length > currentImageIndex + 1) {
      setCurrentImage(currentImageIndex + 1)
    }
  }

  const prevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1)
    }
  }

  const isLastImage = Boolean(imageList.length === currentImageIndex + 1)
  const isFirstImage = Boolean(currentImageIndex === 0)

  const navProps = {
    isLastImage,
    isFirstImage,
    nextImage,
    prevImage,
  }

  const previewProps = {
    isLastImage,
    isFirstImage,
    setCurrentImageIndex,
    imageList,
    currentImageIndex,
  }

  return (
    <CarouselNavigators {...navProps}>
      <CarouselImageView imgInfo={imageList[currentImageIndex]} />
      <CarouselPreview {...previewProps} />
    </CarouselNavigators>
  )
}

export default ImageCarousel
